<p-card
  styleClass="!bg-greyscale-400 hover:!bg-primary-100 hover:cursor-pointer !w-80 h-full !py-8 !px-2"
  [style]="style"
  (click)="navigateTo(link)"
>
  <ng-template pTemplate="header">
    <div class="flex justify-center">
      <!-- Vérifiez si l'icône est une image -->
      <img
        *ngIf="icon.endsWith('.svg')"
        [src]="icon"
        alt="Card Image"
        class="w-full h-full"
      />
      <!-- Sinon, affichez une icône -->
      <i
        *ngIf="!icon.endsWith('.svg')"
        [class]="icon"
        style="font-size: 7rem"
      ></i>
    </div>
  </ng-template>
  <ng-template pTemplate="title">
    <h2 class="text-center">
      {{ title }}
    </h2>
  </ng-template>

  <p class="text-center">
    {{ text }}
  </p>
</p-card>
